"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const tick2_svg_1 = __importDefault(require("../../icons/tick2.svg"));
exports.default = react_1.default.memo(NameInput);
NameInput.defaultProps = {
    minLength: 1,
    disabled: false
};
const useStyles = makeStyles_1.default((theme) => ({
    nameInput: {
        display: "flex",
        flexDirection: "column"
    },
    textBoxContainer: {
        paddingBottom: 4,
        borderBottom: "2px solid #3dc5ee",
        display: "flex",
        justifyContent: "space-between"
    },
    textBox: {
        border: 0,
        padding: 0,
        outline: "none",
        flexGrow: 1
    },
    charsRemaining: {
        marginRight: 12,
        color: "#cccccc"
    },
    submitButton: {
        alignSelf: "center",
        marginTop: 40,
        width: 46,
        height: 46,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#32cd32",
        boxShadow: "0 1px 3px rgba(80,80,80,0.4)",
        "&:hover": {
            backgroundColor: colorManipulator_1.alpha("#32cd32", 0.8)
        },
        "&:disabled": {
            visibility: "hidden"
        }
    },
    buttonSvg: {
        color: "white",
        verticalAlign: "middle",
        pointerEvents: "none"
    }
}));
function NameInput(props) {
    const [text, setText] = react_1.useState("");
    const remainingCharCount = props.maxLength - text.length;
    const classes = useStyles();
    const textBoxRef = react_1.useRef(null);
    function handleSubmit() {
        if (text.length < 1) {
            return;
        }
        props.onSubmit(text);
    }
    function handleInputChange(text) {
        setText(text);
    }
    function handleKeyPress(e) {
        if (e.key === "Enter") {
            handleSubmit();
            e.preventDefault();
        }
    }
    react_1.useLayoutEffect(() => {
        var _a;
        if (!props.disabled) {
            (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [props.disabled]);
    const className = classes.nameInput + (props.className ? " " + props.className : "");
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: classes.textBoxContainer + " " + props.textBoxClassName },
            react_1.default.createElement("input", { className: classes.textBox, ref: textBoxRef, type: "text", value: text, onChange: e => handleInputChange(e.target.value), placeholder: props.placeholderText, onKeyDown: handleKeyPress, minLength: props.minLength, maxLength: props.maxLength, disabled: props.disabled }),
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.charsRemaining }, remainingCharCount)),
        props.children,
        react_1.default.createElement(IconButton_1.default, { disabled: props.disabled || text.length < props.minLength, onClick: handleSubmit, className: classes.submitButton },
            react_1.default.createElement(tick2_svg_1.default, { className: classes.buttonSvg }))));
}
